import { render, staticRenderFns } from "./SecReg.vue?vue&type=template&id=4a1a31cf&scoped=true&"
import script from "./SecReg.vue?vue&type=script&lang=js&"
export * from "./SecReg.vue?vue&type=script&lang=js&"
import style0 from "../../less/login.less?vue&type=style&index=0&id=4a1a31cf&lang=less&scoped=true&"
import style1 from "./SecReg.vue?vue&type=style&index=1&id=4a1a31cf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1a31cf",
  null
  
)

export default component.exports